import { getAsync, postAsync, putAsync, deleteAsync } from "../helpers/apiHelper";

const endpoint = process.env.VUE_APP_BACKEND + "/api/teams";

// GET team by id without related data
export async function getTeamAsync(teamsId) {
  return await getAsync(`${endpoint}/${teamsId}`);
}

// GET all teams for a coach
export async function getTeamsByCoachIdAsync(coachId) {
  return await getAsync(`${endpoint}/GetTeamsByCoachId/${coachId}`);
}

// Get all users in team
export async function getTeamUsersAsync(teamId) {
  return await getAsync(`${endpoint}/GetTeamUsers/${teamId}`);
}

// Get all users not in team
export async function getUsersNotInTeamAsync(teamId) {
  return await getAsync(`${endpoint}/GetUsersNotInTeam/${teamId}`);
}

// Get if a user is part of team
export async function getIsUserPartOfTeamAsync(userId, teamId) {
  return await getAsync(`${endpoint}/GetIsUserPartOfTeam/${userId}/${teamId}`);
}

// GET a coach public name
export async function getCoachPublicNameAsync(coachId) {
  return await getAsync(`${endpoint}/GetCoachPublicName/${coachId}`);
}

// Get all users' coaches
export async function getAllCurrentUserCoachesAsync() {
  return await getAsync(`${endpoint}/GetAllCurrentUserCoaches`);
}

// Affect a list of users to a team
export async function affectUsersToTeamAsync(teamId, usersIds) {
  return await postAsync(`${endpoint}/AffectUsersToTeam/${teamId}`, usersIds);
}

// Remove a user from a team
export async function removeUserFromTeamAsync(TeamId, userId) {
  return await deleteAsync(`${endpoint}/RemoveUserFromTeam/${TeamId}/${userId}`);
}

// CREATE a team
export async function createTeamAsync(federationId, model) {
  return await postAsync(`${endpoint}/${federationId}`, model);
}

// UPDATE a team
export async function updateTeamAsync(coachId, model) {
  return await putAsync(`${endpoint}/${coachId}`, model);
}

// DELETE a team
export async function deleteTeamAsync(teamsId) {
  return await deleteAsync(`${endpoint}/${teamsId}`);
}
